// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YLH2","content":"styles_content__2sCLo"};